/* eslint-disable @typescript-eslint/no-unused-expressions */
import { Grid } from "@mui/material";
import { useParams } from "react-router-dom";
import InjectionMouldingHeader from "../../components/Header";
import InjectionMouldingHyCAPMachineCard from "../components/MachineCard";
import ContentSubHeader from "../../components/ContentSubHeader";
import buildBreadCrumbs from "../../utils/buildBreadCrumb";
import { useInjectionDataContext } from "../../contexts/InjectionDataContext";
import { useLocation } from "react-router-dom";
import axiosInstance from "../../utils/axiosInstance";
import { env } from "../../../../env";
import { useQuery } from "@tanstack/react-query";
import LoadingIndicator from "../../components/Loading";
import ErrorIndicator from "../../components/Error";
import { useSelector } from "react-redux";
import { AppContext } from "../../../../App";
import { useContext } from "react";
const baseURL = env?.microservice_assetsmgt;

function HyCAPMachineView() {
  const { sharedData } = useInjectionDataContext();
  const { selectedPlantForCube }: any = useContext(AppContext);
  const plantList = useSelector((state: any) => state.plantsList);
  const plantName =
    plantList.plants.find(
      (item: any) => item.plant_code === selectedPlantForCube
    )?.plant_name || "";
  const params = useParams(); // Gets all dynamic path segments
  const location = useLocation();
  const {
    assetId,
    tag,
    parentId,
    hycapId,
    hycapChildId,
    hycapSubChildId,
    asset,
  } = location.state || {};

  // Extract the dynamic levels from the params
  const { hycap, hycapchild, hycapsubchild } = params;

  // Build breadcrumb hierarchy dynamically
  const pathLevels = [hycap, hycapchild, hycapsubchild].filter(Boolean);

  // Get current page name from the deepest level
  const currentPage = pathLevels[pathLevels.length - 1] || "HyCap";

  // Determine next page in hierarchy
  //const pageHierarchy = ["Hycap", "HyCapChild1", "HyCapChild2", "HyCapChild3"];
  const previousPage = pathLevels[pathLevels.length - 2];

  const retrieveAssets = async () => {
    const response = await axiosInstance.get(
      `${baseURL}assets?filter=plant_id:oid_eq:${sharedData[0].plantId}&filter=parent_asset:oid_eq:${assetId}&filter=use_case:oid_eq:${sharedData[0].usecaseId}`
    );
    return response.data;
  };

  const {
    data: hycap_assets,
    error,
    isLoading,
  } = useQuery({
    queryKey: [`hycap_assets_${assetId}`],
    queryFn: retrieveAssets,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
  });

  if (isLoading)
    return (
      <div>
        <LoadingIndicator text="Loading HyCAPs Assets....." />
      </div>
    );
  if (error)
    return (
      <div>
        <ErrorIndicator text={`Error Occured : ${error.message}`} />
      </div>
    );

  const appendPaths = {
    2: "machineview",
  };

  const queryParams = {
    1: { aspid: parentId },
  };

  const stateParams = {
    2: {
      assetId: hycapId,
      tag: tag,
      hycapId: hycapId,
      parentId: parentId,
      hycapChildId: hycapChildId,
      hycapSubChildId: hycapSubChildId,
      asset: asset,
    },
    3: {
      assetId: hycapChildId,
      tag: tag,
      hycapId: hycapId,
      parentId: parentId,
      hycapChildId: hycapChildId,
      hycapSubChildId: hycapSubChildId,
      asset: asset,
    },
  };

  return (
    <>
      <InjectionMouldingHeader
        pageHeader={`${currentPage} - Machine Details`}
        navigationItem={buildBreadCrumbs(
          plantName,
          [
            "HyCAPs",
            hycap,
            ...(hycapchild ? [hycapchild] : []),
            ...(hycapsubchild ? [hycapsubchild] : []),
          ],
          appendPaths,
          queryParams,
          stateParams
        )}
      />
      <ContentSubHeader>
        <Grid container>
          <Grid item xs={12} sm={12} md={12} lg={12}>
            <InjectionMouldingHyCAPMachineCard
              machneIdentity={previousPage || currentPage}
              childAssets={hycap_assets.data}
              tag={tag}
              pathParts={pathLevels}
              machineName={currentPage}
              parentId={parentId}
              assetId={assetId}
              hycapId={hycapId}
              hycapChildId={hycapChildId}
              hycapSubChildId={hycapSubChildId}
              params={params}
              asset={asset}
            />
          </Grid>
        </Grid>
      </ContentSubHeader>
    </>
  );
}

export default HyCAPMachineView;
